import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import Chip from 'tio-ui/components/chip';

interface DashboardTileSignature {
  Args: {
    headerText?: string;
    isUrgent?: boolean;
    showAdminBadge?: boolean;
  };
  Blocks: {
    body: [];
    description: [];
    footer: [];
    header: [];
    image: [];
  };
}

const DashboardTileComponent: TOC<DashboardTileSignature> = <template>
  <div
    class="shadow-sm border tio-border-default aspect-square hover:shadow-md w-full h-full relative tio-bg-surface"
  >
    <div
      class="border-b tio-border-subtle px-4 sm:px-2 py-3 h-10 flex flex-row justify-between items-center text-base md:text-base"
    >
      {{#if (has-block "header")}}
        {{yield to="header"}}
      {{else}}
        <h3 class="truncate tio-text-sm-semibold">{{@headerText}}</h3>
        {{#if @isUrgent}}
          <span class="font-semibold tio-fg-danger">
            {{t "dashboard_tiles.to_do_now"}}
          </span>
        {{/if}}
        {{#if @showAdminBadge}}
          <Chip @intent="primary">
            {{t "dashboard_tiles.admin"}}
          </Chip>
        {{/if}}
      {{/if}}
    </div>
    <div
      class="tio-col-flush p-4 sm:p-2 xl:p-4 w-full h-[calc(100%-2.5rem)] overflow-hidden tio-fg-primary text-base md:text-sm xl:text-base"
    >
      {{#if (has-block "body")}}
        {{yield to="body"}}
      {{else}}
        <div class="mb-2">{{yield to="description"}}</div>
        <div class="tio-row-center grow overflow-hidden">
          {{yield to="image"}}
        </div>
      {{/if}}
    </div>
    {{#if (has-block "footer")}}
      <div class="absolute bottom-0 right-0">
        {{yield to="footer"}}
      </div>
    {{/if}}
  </div>
</template>;

export default DashboardTileComponent;
